import React from 'react'
import './style.scss'

import ArrowCta from '../arrow-cta'

let firstLoad = true

class Header extends React.Component {
  render () {
    let headerClasses = [
      this.props.template === 'secondary' && 'header-secondary header--absoluteSlash',
      this.props.template === 'login' && 'header-login'
    ].join(' ')
    const wrapperClasses = this.props.template === 'home' ? 'header-flexWrapper' : ''
    const separatorClasses = this.props.template === 'home' ? 'header-separator' : ''
    firstLoad ? '' : headerClasses = headerClasses + ' header--alreadyLoadedOnce'
    firstLoad = false
    return (
      <header className={`header ${headerClasses}`} style={{backgroundImage: 'url(' + this.props.bgImage + ')'}}>
        <div id='header-wrapper' className='header-wrapper'>
          <div className='container u-alignCenter--ipad'>
            <div className={wrapperClasses}>
              {this.props.template === 'home' ? <h1 className='header-title' dangerouslySetInnerHTML={{__html: this.props.headingText}} />
                : <h2 className='header-title header-title--secondary' dangerouslySetInnerHTML={{__html: this.props.headingText}} /> }
              {this.props.subheadingText ? <h5 className='header-subheading'>{this.props.subheadingText}</h5> : '' }
              <div className={separatorClasses}>
                <hr className='u-marginBottomSmall' />
                {this.props.template === 'home' ? <ArrowCta text={this.props.arrowText} link='#mainContent' /> : '' }
              </div>
            </div>
          </div>
        </div>
      </header>
    )
  }
}

export default Header



// WEBPACK FOOTER //
// ./src/components/header/index.js